import { combineReducers } from 'redux';
import { loginFormReducer } from './components/loginForm/reducers/loginFormReducer';

export default combineReducers({
  'loginForm': loginFormReducer
});



// WEBPACK FOOTER //
// ./src/pages/login/rootReducer.js